import mergeWith from 'lodash-es/mergeWith';
import defaultsDeep from 'lodash-es/defaultsDeep';
import pick from 'lodash-es/pick';
export function merge_by_template(value, template) {
  return mergeWith(value, template, function(valueObject, templateObject) {
    const value = defaultsDeep(valueObject, templateObject);
    return {
      ...pick(value, Object.keys(templateObject))
    };
  });
}
